module.exports = __webpack_public_path__ + "static/img/gr-847-345bb.cc2119e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gr-847-345bb.jpg
// module id = IVXy
// module chunks = 0